import {inject} from '@angular/core';
import {CanMatchFn, Route, Router, UrlSegment} from '@angular/router';
import {AuthStore} from '../../+store/auth.store';

export function LoginMatcher(): CanMatchFn {
	return (route: Route, segments: UrlSegment[]) => {
		const authStore: AuthStore = inject(AuthStore);
		const router: Router = inject(Router);
		if (authStore.isAuthenticated()) {
			if (route.path !== 'home') router.navigate(['home']);
			return false;
		}
		// navigate to 'login' page if the user not in login page
		else if (route.path === 'login') return true;
		router.navigate(['login']);
		return false;
	};
}
